import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  SOCIAL_LOGIN,
  SOCIAL_LOGIN_SUCCESS,
  COMPANY_SETTING_SUCCESS,
  ACCESS_SETTING_SUCCESS,
  USER_DETAILS_SUCCESS,
  REDIRECT_LOGIN_SUCCESS,
  REDIRECT_LOGIN,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  redirect_userDetail: null
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case SOCIAL_LOGIN:
      console.log("REDUCER --------- LOGIN USER SSO")
      state = {
        ...state,
        loading: true,
      }
      break
    case SOCIAL_LOGIN_SUCCESS:
      state = {
        ...state,
        userDetail: action.payload.data,
        loading: false,
      }
      break
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      }
      break
    case LOGIN_SUCCESS:
      state = {
        ...state,
        userDetail: action.payload.data,
        loading: false,
      }
      break
    case LOGOUT_USER:
      state = { ...state }
      break
    case LOGOUT_USER_SUCCESS:
      state = { ...state }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case COMPANY_SETTING_SUCCESS:
      state = { ...state, userDetails: action.payload }
      break

    case ACCESS_SETTING_SUCCESS:
      state = { ...state, accessDetails: action.payload }
      break

    case USER_DETAILS_SUCCESS:
      state = { ...state, usersDetails: action.payload }
      break
    // aplication once click redirect login to dashboard or verify screen
    case REDIRECT_LOGIN:
      state = {
        ...state,
        redirect_userDetail: null,
        loading: true,
      }
      break
    case REDIRECT_LOGIN_SUCCESS:
      state = {
        ...state,
        redirect_userDetail: action.payload,
        loading: false,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default login
